import { Icon, Input } from '@ics-portal/guardian';
import { type ReactNode } from 'react';

interface TableHeaderProps {
    searchTerm: string;
    searchTermChange: (value: string) => void;
    headerSuffix?: ReactNode;
}

export function TableHeader(props: TableHeaderProps): ReactNode {
    const { searchTerm, searchTermChange, headerSuffix } = props;

    return (
        <div className="flex align-items-center justify-content-between w-full">
            <Input
                wrapperClassName="gap-0 w-13rem"
                labelHidden
                key="search"
                id="search"
                name="search"
                onChange={(e) => {
                    searchTermChange(e.target.value);
                }}
                placeholder="Search components"
                value={searchTerm}
                prefixIcon={<Icon name="search" />}
            />
            {headerSuffix}
        </div>
    );
}
